import { Component, Input, OnInit} from '@angular/core';
import { JobPositions, OrdersList, StatusButtons } from "../../../../_shared/interfaces";
import {AlertService, IAlertType, OrdersStoreService} from "../../../../_shared/services";
import { ClrDatagridSortOrder } from "@clr/angular";
import {CurrencyPipe, NgForOf, NgIf} from "@angular/common";
import {RouterLink} from "@angular/router";

@Component({
  selector: 'app-job-details-orders',
  standalone: true,
  imports: [
    NgIf,
    NgForOf,
    RouterLink,
    CurrencyPipe
  ],
  templateUrl: './job-details-orders.component.html',
  styleUrl: './job-details-orders.component.sass'
})
export class JobDetailsOrdersComponent implements OnInit {
  orders: OrdersList[] = [];
  projectid: string = '';
  loading: boolean = true;
  statusLabel = 'label-light-blue';
  statusText = '';
  descSort = ClrDatagridSortOrder.DESC;

  @Input() ordprid: string = '';
  @Input() ordposid: string = '';
  @Input() ordpartid: number = 0;
  @Input() jobid: number = 0;

  statusButtons: StatusButtons[] = [
    { state: 'open', display: 'Entwurf', label: 'alert-info', icon: 'info-circle'},
    { state: 'confirmed', display: 'Bestätigt', label: 'alert-info', icon: 'check-circle'},
    { state: 'running', display: 'Abgeschickt', label: 'alert-warning', icon: 'exclamation-triangle'},
    { state: 'overdue', display: 'Überfällig', label: 'alert-danger', icon: 'exclamation-circle'},
    { state: 'incomplete', display: 'Unvollständig', label: 'alert-warning', icon: 'exclamation-triangle'},
    { state: 'storno', display: 'Storniert', label: 'alert-warning', icon: 'exclamation-triangle'},
    { state: 'shipped', display: 'Abgeschickt', label: 'alert-info', icon: 'check-circle'},
    { state: 'invoiced', display: 'Berechnet', label: 'alert-green', icon: 'exclamation-circle'},
    { state: 'done', display: 'Erledigt', label: 'alert-success', icon: 'info-circle'}
  ];

  constructor(
    private ordss: OrdersStoreService,
    private alertDispatcher: AlertService,
  ) { }

  ngOnInit() {
    this.loading = true;
    this.loadOrdersPositions(this.ordprid, this.jobid, this.ordposid, this.ordpartid);
    this.descSort = ClrDatagridSortOrder.DESC;
  }

  loadOrdersPositions(projectid: string, jobid: number, position: string, part: number) {
    let partID = part.toString();
    this.ordss.getOrdersPositions(projectid, 0, jobid, position, partID).subscribe({
      next: data2 => {
        if (!data2 || !data2.object || data2.object.length === 0) {
          this.alertDispatcher.alertConfig.message = 'Keine Orderdaten gefunden!';
          this.alertDispatcher.alertConfig.clrAlertType = IAlertType.WARNING;
          return;
        }
        this.orders = data2.object;
      },
      complete: () => {
        this.loading = false;
      },
      error: () => {
        return
      }
    })
  }

  // Anpassung Farbe und Text des Statusbuttons...
  findButtonStatus(projectstatus: string, buttons: StatusButtons[]) {
    return buttons.findIndex(el => el.state === projectstatus)
  };

  getCellStatus(status: string) {
    const statusline = this.findButtonStatus(status, this.statusButtons);
    return {
      'statusLabel': this.statusButtons[statusline].label,
      'statusDisplay': this.statusButtons[statusline].display,
      'statusIcon': this.statusButtons[statusline].icon
    };
  }

  findButtonClass(invoicestatus: string) {
    return "alert " + this.getCellStatus(invoicestatus).statusLabel + " alert-sm";
  }
}
